var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "landingpage-banner__container",
      style: { height: "calc(100vh - " + _vm.headerHeight + "px)" }
    },
    [
      _c("div", { staticClass: "landingpage-banner__img-wrapper" }, [
        _c("img", {
          staticClass: "landingpage-banner__img",
          attrs: {
            src:
              _vm.isMobile && _vm.imgMobile !== ""
                ? _vm.imgMobile
                : _vm.imgDesktop,
            alt: _vm.headline
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "landingpage-banner__content-wrapper" }, [
        _c("h1", {
          staticClass: "landingpage-banner__headline",
          style: { color: _vm.headlineColor },
          domProps: { innerHTML: _vm._s(_vm.headline) }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "landingpage-banner__txt",
          domProps: { innerHTML: _vm._s(_vm.txt) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "landingpage-banner__btn-wrapper" }, [
          _vm.realButtonUrl1 != "" && _vm.btnTxt1 != ""
            ? _c(
                "a",
                {
                  staticClass: "landingpage-banner__btn",
                  class: {
                    "landingpage-banner__btn--primary":
                      _vm.btnStyle1 === "primary",
                    "landingpage-banner__btn--secondary":
                      _vm.btnStyle1 === "secondary"
                  },
                  attrs: { href: _vm.realButtonUrl1 }
                },
                [_vm._v(_vm._s(_vm.btnTxt1))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.realButtonUrl1 != "" && _vm.btnTxt2 != ""
            ? _c(
                "a",
                {
                  staticClass: "landingpage-banner__btn",
                  class: {
                    "landingpage-banner__btn--primary":
                      _vm.btnStyle2 === "primary",
                    "landingpage-banner__btn--secondary":
                      _vm.btnStyle2 === "secondary"
                  },
                  attrs: { href: _vm.realButtonUrl2 }
                },
                [_vm._v(_vm._s(_vm.btnTxt2))]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }